import { css } from "@emotion/react";

import { Colors, Text } from "@zapier/design-system";

type TaskLimitDropdownSubstituteProps = {
  /** The background color of the component. */
  color?: string;
  /** The text to display. */
  text: string;
};

const rootStyles = (color: string) => css`
  align-items: center;
  background: ${color};
  border: 1px solid ${Colors.neutral400};
  border-radius: none;
  display: flex;
  height: 44px;
  padding: 0 15px;
`;

/**
 * Used in place of a `TaskLimitDropdown` component when there's only one item to display.
 */
export const TaskLimitDropdownSubstitute = ({
  color = Colors.neutral100,
  text,
}: TaskLimitDropdownSubstituteProps) => (
  <div css={rootStyles(color)}>
    <Text fontWeight={600} tag="p" type="smallPrint1">
      {text}
    </Text>
  </div>
);
